import { RootState } from '../store';

export const appInfoSelector = (state: RootState) => state.appInfo.app;
